export default function buildGetListingTagTree({
    apiEndpoint,
    apiTools
}) {
    return async function getListingTagTree(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/tree?idShop=41`
        })
       
        const res = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            },
            credentials: 'include',
        });
        return await res.json();
    }
}